export default __webpack_public_path__ + "static/media/ndxbl.5c3b8434.png";